import { useRef, type ReactElement } from 'react';
import { Button, Modal } from '../ui/kit/index.js';

export interface ConfirmDialogProps {
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel?: string | null;
  /** Confirm-button caption while the action runs. */
  busyLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  title,
  description,
  confirmLabel,
  cancelLabel = 'Отмена',
  busyLabel = 'Сохраняем…',
  danger = false,
  busy = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps): ReactElement {
  const cancelRef = useRef<HTMLButtonElement | null>(null);
  const confirmRef = useRef<HTMLButtonElement | null>(null);

  return (
    <Modal
      as="section"
      layer="confirm"
      overlayClassName="deck-modal-backdrop"
      className="deck-modal"
      labelledBy="deck-confirm-title"
      describedBy="deck-confirm-description"
      initialFocusRef={cancelLabel === null ? confirmRef : cancelRef}
      backdropEvent="mouseDown"
      lockBodyScroll={false}
      busy={busy}
      onClose={onCancel}
    >
      <h2 id="deck-confirm-title">{title}</h2>
      <p id="deck-confirm-description">{description}</p>
      <Modal.Actions className="deck-modal-actions">
        {cancelLabel === null ? null : (
          <Button ref={cancelRef} variant="secondary" size="compact" disabled={busy} onClick={onCancel}>
            {cancelLabel}
          </Button>
        )}
        <Button
          ref={confirmRef}
          variant={danger ? 'danger' : 'primary'}
          size="compact"
          disabled={busy}
          onClick={onConfirm}
        >
          {busy ? busyLabel : confirmLabel}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
